<template>
    <DataHeader class="wrap-block-table">
        <div class="dataHeaderTitle" slot="title">
            <div class="mid-wrap-title">
                <span>{{baseInfo.$name}}</span>
                <span class="seven-title">{{days}}资金累计净流入</span>
                <span class="seven-up-down" :class="baseInfo.$curInflow>0?'up':'down'">{{baseInfo.$curInflow | formatterMoney(2)}}</span>
                <span class="seven-title">区间涨跌幅</span>
                <span class="seven-up-down" :class="baseInfo.$change>0?'up':'down'">{{baseInfo.$change | formatUnit('%')}}</span>
                <span v-if="tableData && tableData.update" class="data-date">数据日期：{{tableData.update}}</span>            
            </div>
        </div>
        <div class="mid-wrap-cont" slot="cont">
            <GeminiScrollbar :minThumbSize="120">
                <table width="100%">
                    <thead>
                        <tr>
                            <th v-for="(item, index) in tableHead" 
                                :key="index"
                                @click="sortByTitle(index)"
                                :class="{'hover':index>2}"    
                            >
                                <span :class="{margin2:index>2}">{{item}}</span>
                                <div v-if="index>2" class="icon-title-up" :class="{sort:index===sortIndex&&!upOrDown}" ></div>
                                <div v-if="index>2" class="icon-title-down" :class="{sort:index===sortIndex&&upOrDown}" ></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="tableData.stock">
                        <tr v-for="(item, index) in tableData.stock"
                            :key="item.id"
                            @click="trClick(index, {code: item.code, market:item.market_code})"
                            @dblclick="trDbcick(item.code, item.market_code)"
                            :class="index===activeTr?'tr-active':''" >
                            <td>{{index + 1}}</td>
                            <td class="active-code">{{item.code}}</td>
                            <td style="max-width:70px">{{item.name}}</td>
                            <td :class="item.change>0?'up':(item.change<0?'down':'')">{{item.change | formatterMoney(2) | formatUnit('%')}}</td>
                            <td :class="item.inflow>0?'up':(item.inflow<0?'down':'')">{{item.inflow | formatterMoney(2) | formatUnit('')}}</td>
                            <td :class="item.five_inflow>0?'up':(item.five_inflow<0?'down':'')">{{item.five_inflow | formatterMoney(2) | formatUnit('')}}</td>
                            <td :class="item.five_change>0?'up':(item.five_change<0?'down':'')">{{item.five_change | formatterMoney(2) | formatUnit('%')}}</td>
                            <td :class="item.twenty_inflow>0?'up':(item.twenty_inflow<0?'down':'')">{{item.twenty_inflow | formatterMoney(2) | formatUnit('')}}</td>
                            <td :class="item.twenty_change>0?'up':(item.twenty_change<0?'down':'')">{{item.twenty_change | formatterMoney(2) | formatUnit('%')}}</td>
                        </tr>
                    </tbody>
                </table>
            </GeminiScrollbar>
        </div>
    </DataHeader>
</template>

<script>
import DataHeader from '../dataHeader/dataHeader'
import { getConceptData } from '../../assets/js/action'
import { sortByKey } from '../../assets/js/utils'
import event from '../event'

export default {
    props: {
        baseInfo: Object,
        days: String
    },
    data() {
        return {
            tableHead: ['', '代码', '名称', '涨幅', '昨日港资净流向', '近5日港资净流向', ' 近5日涨幅', '近20日港资净流向', '近20日涨幅'],
            tableData: {},
            sortKey: ['', '', '', 'change', 'inflow', 'five_inflow', 'five_change', 'twenty_inflow', 'twenty_change'],
            activeTr: -1,
            sortIndex: -1,
            upOrDown: true,
            statFlag: false, // 因第一次点击为自动点击，不触发埋点
        }
    },
    mounted() {
        this.getConceptList(this.baseInfo.$code)
    },
    methods: {
        getConceptList(code) {
            getConceptData(code).then(data => {
                this.tableData = data.data.data
                //当板块切换时股票排序顺序和上一个板块排序顺序保持一致
                this.sortWithBlockListChange(this.sortIndex);
                this.trClick(0, {code:this.tableData.stock[0].code, market:this.tableData.stock[0].market_code})
            })
        },
        sortByTitle(index) {
            this.sortIndex = index
            let sortKey = this.sortKey[index]
            this.upOrDown = !this.upOrDown
            this.tableData.stock = this.upOrDown ? 
                this.tableData.stock.sort(sortByKey(sortKey)) :
                this.tableData.stock.sort(sortByKey(sortKey, true))

            // 埋点
            window.TA.log({
                id: 'webhsgt_rlt_list_rank'
            })
        },

        sortWithBlockListChange(index){
            if(index === -1) {
                return;
            }
            const  sortKey = this.sortKey[index];
            this.tableData.stock = this.upOrDown ? 
                this.tableData.stock.sort(sortByKey(sortKey)) :
                this.tableData.stock.sort(sortByKey(sortKey, true));
        },

        trClick(index, info) {
            this.activeTr = index
            event.set('info', info)
            if (this.statFlag) {
                window.TA.log({
                    id: `webhsgt_rlt_list_click`
                })
            }
            this.statFlag = true
        },
        trDbcick(code, marketid) {
            if (marketid == 177) {
                code = code.toString().split('')
                code[0] = 'HK'
                code = code.join('')
            }
            if (window.API) {
                window.API.use({
                    method: 'Quote.switchCode',
                    data: code
                });
            }
            window.TA.log({
                id: `webhsgt_stocklist_list_doubleclick`
            })
        }
    },
    components: {
        DataHeader
    },
    watch: {
        baseInfo(val) {
            this.tableData = {}
            this.getConceptList(val.$code)
        }
    }
}
</script>

<style lang="less">
.wrap-block-table {
    margin: 0 6px;
    .dataHeaderSign {
        margin-left: 7px;
    }
    .mid-wrap-title {
        font-family: SimSun;
        .seven-title {
            color: #f6ff93;
            margin-left: 15px;
            font-size: 12px;
        }
        .seven-up-down {
            margin-left: 7px;
            font-size: 12px;
        }
    }
    .mid-wrap-cont {
        height: 648px;
        background: #1b1b1b;
        text-align: center;
        font-size: 12px;
        color: #aaaaaa;
        .gm-scrollbar {
            .thumb { 
                width: 8px !important;
                background: #404040 !important;
                top: 30px;
            }
        }
        .gm-scroll-view {
            width: 751px !important;
        }
        table {
            thead {
                tr {
                    background: #2a2a2a;
                    th {
                        height: 30px;
                        line-height: 30px;
                        position: relative;
                        .icon-title-up, .icon-title-down {
                            width: 0;
                            height: 0;
                            display: inline-block;
                            overflow: hidden;
                            font-size: 0;
                            line-height: 0;
                            border-width: 4px;
                            position: absolute;
                            right: 0;
                        }
                        .margin2 {
                            display: inline-block;
                            margin-right: 2px;
                        }
                        .icon-title-up {
                            top: 6px;
                            right: inherit;
                            border-style: dashed dashed solid dashed;
                            border-color: transparent transparent #aaaaaa transparent;
                            &.sort {
                                border-color: transparent transparent #109aff transparent;
                            }
                        }
                        .icon-title-down {
                            top: 15px;
                            right: inherit;
                            border-style: solid dashed dashed dashed;
                            border-color: #aaaaaa transparent transparent transparent;
                            &.sort {
                                border-color: #109aff transparent transparent transparent;
                            }
                        }
                        &.hover:hover {
                            cursor: pointer;
                        }
                        &:last-child {
                            padding-right: 8px;
                        }
                    }
                }
            }
            tbody {
                tr {
                    td {
                        height: 30px;
                        line-height: 30px;
                        &.up { color: '#ff2b32'; }
                        &.down { color: '#20ad43'; }
                    }
                    &:hover {
                        background: #343434;
                    }
                    &.tr-active {
                        background: #1f2837;
                    }
                     &:hover {
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .data-date {
        position: absolute;
        right: 20px;
        font-size: 12px;
        top: 0;
        color: #d2d2d3;
    } 
}

.newgrey{
    .wrap-block-table{
        border-left: 1px solid #2e2e33;
        border-right: 1px solid #2e2e33;
        .mid-wrap-title{
            .seven-title{
                color: #d0d1d2;  
            }
        }
        .mid-wrap-cont{
            background: #181c21;
            color: #d0d1d2;
            .gm-scrollbar {
                .thumb { 
                    background: #393941 !important;
                }
            }
            table{
                thead{
                    tr{
                        background: #181c21;
                        th{
                            .icon-title-up {
                                top: 6px;
                                right: inherit;
                                border-style: dashed dashed solid dashed;
                                border-color: transparent transparent #aaaaaa transparent;
                                &.sort {
                                    border-color: transparent transparent #1b63d9 transparent;
                                }
                            }
                            .icon-title-down {
                                top: 15px;
                                right: inherit;
                                border-style: solid dashed dashed dashed;
                                border-color: #aaaaaa transparent transparent transparent;
                                &.sort {
                                    border-color: #1b63d9 transparent transparent transparent;
                                }
                            }
                        }
                    }
                }
                tbody{
                    tr{
                        td{
                            &.up { color: '#cd4746'; }
                            &.down { color: '#20ac2b'; }
                        }
                        &:hover {
                            background: #34517d;
                        }
                        &.tr-active {
                            background: #34517d;
                        }
                    }
                }
            }
        }
        .data-date{
            color: #fff;
        }
    }
}

.newblack{
    .wrap-block-table{
        border-left: 1px solid #cbcbe1;
        border-right: 1px solid #cbcbe1;
        .mid-wrap-title{
            .seven-title{
                color: #272841;  
            }
        }
        .mid-wrap-cont{
            background: #fff;
            color: #272841;
            .gm-scrollbar{
                .thumb{
                    background: rgba(75,75,114,0.4) !important;
                }
            }
            table{
                thead{
                    tr{
                        background: #f3f3fa;
                        th{
                            .icon-title-up {
                                top: 6px;
                                right: inherit;
                                border-style: dashed dashed solid dashed;
                                border-color: transparent transparent #aaaaaa transparent;
                                &.sort {
                                    border-color: transparent transparent #1b63d9 transparent;
                                }
                            }
                            .icon-title-down {
                                top: 15px;
                                right: inherit;
                                border-style: solid dashed dashed dashed;
                                border-color: #aaaaaa transparent transparent transparent;
                                &.sort {
                                    border-color: #1b63d9 transparent transparent transparent;
                                }
                            }
                        }
                    }
                }
                tbody{
                    tr{
                        td{
                            color: rgba(39, 40, 65 0.8);
                            &.up { color: '#cd4746'; }
                            &.down { color: '#20ac2b'; }
                        }
                        &:hover {
                            background: #d4e1f8;
                        }
                        &.tr-active {
                            background: #d4e1f8;
                        }
                    }
                }
            }
        }
        .data-date{
            color: #272841;
        }
    }
}

.newclassic{
    .wrap-block-table{
        .mid-wrap-title{
            .seven-title{
                color: #d0d1d2;  
            }
        }
        .mid-wrap-cont{
            background: #1b1b1b;
            color: #aaaaaa;
            table{
                thead{
                    tr{
                        background: #23252a;
                        th{
                            .icon-title-up {
                                top: 6px;
                                right: inherit;
                                border-style: dashed dashed solid dashed;
                                border-color: transparent transparent #aaaaaa transparent;
                                &.sort {
                                    border-color: transparent transparent #ff2b48 transparent;
                                }
                            }
                            .icon-title-down {
                                top: 15px;
                                right: inherit;
                                border-style: solid dashed dashed dashed;
                                border-color: #aaaaaa transparent transparent transparent;
                                &.sort {
                                    border-color: #ff2b48 transparent transparent transparent;
                                }
                            }
                        }
                    }
                }
                tbody{
                    tr{
                        td{
                            &.up { color: '#ff2b32'; }
                            &.down { color: '#20ad43'; }
                        }
                        &.tr-active {
                            background: rgba(43, 43, 49, 0.51);
                        }
                    }
                }
            }
        }
        .data-date{
            color: #fff;
        }
    }
}
</style>
